<div
  class="textarea-wrapper"
  [ngClass]="{
    focus: !readOnly && (hasFocus$ | async),
    'has-error': fieldControl.dirty && fieldControl.invalid,
    responsive: responsive
  }"
>
  <label
    class="textarea-label field-label"
    [class.visually-hidden]="!showLabel || !label"
    [attr.for]="fieldId"
    [attr.type]="'textarea'"
  >
    {{ label }}
  </label>

  <!-- make sure autocomplete dropdown gets the appropriate positioning - TODO: update dropdown style -->
  <div class="autocomplete-helper">
    <textarea
      #textarea
      i2gInput
      class="textarea"
      [ngClass]="{
        full: textarea.value.length === maxlength,
        responsive: responsive
      }"
      [i2gFocusable]="focusableTrigger$"
      tabindex="0"
      [i2gDynamicResize]="dynamicResize"
      [attr.id]="fieldId"
      [attr.placeholder]="placeholder"
      [formControl]="fieldControl"
      [attr.data-e2e-id]="textareaE2eId"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      [rows]="rows"
      [readonly]="readOnly"
      (blur)="handleBlur()"
      (focus)="handleFocus()"
      [attr.autocomplete]="removeNativeAutocomplete ? 'i2g' : 'off'"
      [i2gAutoComplete]="autoCompleteOptions"
      (autoCompleteFetchStart)="autoCompleteFetchStart.emit()"
      (autoCompleteFetchEnd)="autoCompleteFetchEnd.emit($event)"
      (autoCompleteSet)="autoCompleteSet.emit($event)"
      (autoCompleteHide)="autoCompleteHide.emit()"
      (autoCompleteDestroy)="autoCompleteDestroy.emit()"
    ></textarea>
  </div>

  <div class="helper">
    <div *ngIf="hasError; else helperText">
      <i2g-error-message
        class="error-message"
        [dirty]="fieldControl.dirty"
        [invalid]="fieldControl.invalid"
        [errorMessage]="errorMessage"
      >
      </i2g-error-message>
    </div>

    <ng-template #helperText>
      <div *ngIf="helpText" class="help-text">
        {{ helpText }}
      </div>
    </ng-template>

    <div *ngIf="showCounter" class="counter" [class.has-error]="hasError">
      {{ textarea.value.length }}/{{ maxlength }}
    </div>
  </div>
</div>

<div *ngIf="isDisabled" class="mask"></div>
